import { dispatcher, ingenuity } from "@quest/base-core";
import { SlotConstantsBehavior, SlotEventConstantsBehavior } from "@quest/murka-games-behavior-panther";
import { TopLogoViewFg } from "@quest/murka-games-behavior-panther/dist/Game/TopLogo/TopLogoViewFg";

export class TopLogoViewfgGame extends TopLogoViewFg{
   
  protected resize(e?: any): void {
     if (!ingenuity.deviceEnv.isDesktop) {
            if (this.CurrentOrientation !== ingenuity.deviceEnv.getOrientation()) {
                this.CurrentOrientation = ingenuity.deviceEnv.getOrientation();
                this.updateOrientation();
            }
        }
    super.resize(e);
  }
   public topSpace(): void {
       if (this.currentStateView) {
            const logoHeightBg = this.getShapeById("logoHeightBg");
            if (logoHeightBg) {
                const wrapperTopBarHeight = SlotConstantsBehavior.WrapperTopBarHeightMobilePortrait;
                const reelBgHeight = SlotConstantsBehavior.REEL_MAXSCALE_HEIGHT;
                /* we use window.innerHeight/2 + SlotConstantsBehavior.ADD_IN_Y as it's the basegame view's position
                 * did not used this.currentView.y to handle in pola
                 * to remove glitch during pola
                 */
                const topSpace = ((window.innerHeight / 2 + SlotConstantsBehavior.ADD_IN_Y) - (reelBgHeight / 2) * this.currentStateView.scale.x) - (wrapperTopBarHeight);
                const availableScaling = Math.min(topSpace / logoHeightBg.height, window.innerWidth / logoHeightBg.width);
                dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_LANDSCAPE_LOGO);
                this.showView();
                this.scale.set(availableScaling);
                this.pivot.set(logoHeightBg.width / 2, logoHeightBg.height / 2);               
                this.x = window.innerWidth / 2;
                this.y = wrapperTopBarHeight + topSpace / 2;
            }
            if(ingenuity.configData.showLogoBaseGameScreen){
                ingenuity.currentGame.stage.addChild(this);
            }
        }
     
    }
}